import { validStatus } from "@/utils/helpers";
import api from "../config/api";

export const getAllAccounts = async (userId) => {
  if (!userId) {
    throw new Error("[GET_ALL_ACCOUNT] User ID missing.");
  }

  const { data } = await api.get(`/platform/accounts/${userId}`);

  return data;
};

export const getAccountBalance = async (userId) => {
  if (!userId) {
    throw new Error("[GET_ACCOUNT_BALANCE] User ID missing");
  }

  const { data } = await api.get(`/platform/accounts/${userId}/balance`);

  return data;
};

export const getAccountStatement = async (statementData) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${statementData.accessToken}`,
      },
      validateStatus: validStatus,
    };

    const response = await api.get(
      `/platform/accounts/statement?month=${statementData.statementMonth}&year=${statementData.statementYear}`,
      config,
    );
    const byteCharacters = atob(response.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: "application/pdf" });

    const fileURL = URL.createObjectURL(file);

    const downloadFile = () => {
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = `AccountStatement_${statementData.statementYear}-${statementData.statementMonth}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    downloadFile();

    return { success: true };
  } catch (error) {
    console.log("Error fetching account statement: ", error);

    let error_message =
      error.response && error.response.status === 401
        ? "Your session has expired. Please log out and log in again."
        : `Error fetching account statement: ${error.message}`;

    throw new Error(error_message);
  }
};
